//import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { useCartStore } from '@features/cart/model/useCartStore'
import { GoToCheckout } from '@features/go-to-checkout'

import { useZonesFromAddress } from '@shared/hooks/useZonesFromAddress'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'


interface CartFooterProps {
  className?: string;
}

export default function CartFooter ({ className }: CartFooterProps) {
  const { t: tca } = useTranslation('cart')
  const { cartInfoData: cartTotal, isSyncing } = useCartStore()
  const {
    minOrderCost,
    isPickup,
    /* freeSlotDeliveryCostFrom,
    deliveryCost, */
    loading: zonesLoading,
  } = useZonesFromAddress()
  //const [ showDeliveryList, setShowDeliveryList ] = useState(false)

  const total = cartTotal?.totals?.total as number
  const isLoading = isSyncing || zonesLoading

  const renderButton = () => {
    if (isLoading) {
      return (
        <SkeletonTheme>
          <Skeleton
            count={1}
            width="100%"
            height={56}
            style={{ borderRadius: 12 }}
          />
        </SkeletonTheme>
      )
    }

    if (!isPickup() && total < minOrderCost) {
      return (
        <Button disabled size="large">
          {tca('preview.min_order_message', {
            minOrderCost: formatPrice(minOrderCost),
            amount: formatPrice(minOrderCost - total),
          })}
        </Button>
      )
    }

    return (
      <GoToCheckout />
    )
  }

  /* const renderDeliveryInfo = () => {
    if (isLoading) {
      return (
        <SkeletonTheme>
          <Skeleton
            count={1}
            width="100%"
            height={56}
            style={{ borderRadius: 12 }}
          />
        </SkeletonTheme>
      )
    }

    if (isPickup()) {
      return null
    }

    return (
      <div
        className={styles['root__delivery-cost']}
        onClick={() => setShowDeliveryList((prev) => !prev)}
      >
        <ReactSVG
          className={styles['root__delivery-cost__icon']}
          src="/icons/moped.svg"
          wrapper="span"
        />
        <span className={styles['root__delivery-cost__text']}>
          {total < freeSlotDeliveryCostFrom ? (
            <>
              {tca('delivery.amount_to_free', {
                amount: formatPrice(freeSlotDeliveryCostFrom - total),
              })}
            </>
          ) : (
            <span className={styles['root__delivery-cost__text--underlined']}>
              {tca('delivery.free')}
            </span>
          )}
        </span>
        {showDeliveryList && (
          <div className={styles['root__delivery-list']}>
            <p>
              {tca('delivery.conditions.under_min', {
                minOrderCost: formatPrice(minOrderCost),
                deliveryCost: formatPrice(deliveryCost),
              })}
            </p>
            <p>
              {tca('delivery.conditions.over_free', {
                freeSlotDeliveryCostFrom: formatPrice(freeSlotDeliveryCostFrom),
              })}
            </p>
          </div>
        )}
      </div>
    )
  } */

  return (
    <div className={cn(styles.cartFooter, className)}>
      <div className={styles.cartFooter__summary}>
        <div className={styles.cartFooter__row}>
          <span className={styles.cartFooter__label}>
            {tca('total.total')}:
          </span>
          <span className={styles.cartFooter__total}>
            {formatPrice(cartTotal?.totals?.total as number)}
          </span>
        </div>

        {!!cartTotal?.totals?.sale && (
          <div className={styles.cartFooter__row}>
            <span className={styles.cartFooter__label}>
              {tca('total.discount')}:
            </span>
            <span className={styles.cartFooter__discount}>
              -{formatPrice(cartTotal.totals.sale)}
            </span>
          </div>
        )}
      </div>

      <div className={styles.cartFooter__actions}>
        
        {renderButton()}
      </div>
    </div>
  )
}
